import { render, staticRenderFns } from "./QuoterHistory.vue?vue&type=template&id=33b47f72&"
import script from "./QuoterHistory.vue?vue&type=script&lang=js&"
export * from "./QuoterHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports